export default __webpack_public_path__ + "static/media/ourTeamBack.33ac4674.png";